
import { Injectable } from '@angular/core';
import { throwError as observableThrowError, BehaviorSubject, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@myenv/environment';
import { HttpHeaders, HttpClient, HttpBackend } from '@angular/common/http';

@Injectable()
export class AdminService {
  sideData: any[] = [];

  private messageSource = new BehaviorSubject(this.sideData);
  currentMessage = this.messageSource.asObservable();
  public apiUrl = environment.apiUrl;
  private httpClient: HttpClient;

  // To get the side menu
  getSideMenu() {
    const users = {
      name: 'menu.USER',
      img: 'regular fa-circle-user',
      route: '/admin/users'
    };
    const roles = {
      name: 'menu.ROLE',
      img: 'unlock-alt',
      route: '/admin/roles'
    };
    const groups = {
      name: 'menu.GROUP',
      img: 'users',
      route: '/admin/groups'
    };
    this.sideData = [];
    const permissionModules = JSON.parse(localStorage.getItem('permissionModules') || '[]');
    const sidedata = this.sideData;
    if (permissionModules.includes('USER')) sidedata.push(users);
    if (permissionModules.includes('ROLE')) sidedata.push(roles);
    if (
      permissionModules.includes('GROUP') ||
      permissionModules.includes('USER') ||
      permissionModules.includes('ROLE') ||
      permissionModules.includes('ADMIN')
    ) {
      sidedata.push(groups);
    }
    return sidedata;
  }

  constructor(
    private http: HttpClient,
    private handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler);
  }

  changeMessage(message: any) {
    this.messageSource.next(message);
  }

  uploadLogo(data: any): Observable<any> {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + token,
      // 'Content-Type': 'multipart/form-data'
    });
    return this.httpClient.post(this.apiUrl + 'users/logo', data, { headers }).pipe(
      catchError(this.handleError));
  }

  handleError(error: any | any) {
    return observableThrowError(error.error || error || 'Server error');
  }
}
